import { render, staticRenderFns } from "./specialReturn.vue?vue&type=template&id=e20fe7d2"
import script from "./specialReturn.vue?vue&type=script&lang=js"
export * from "./specialReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports